import gql from 'graphql-tag';

export const listUserPoolClients = gql`
  query {
    listUserPoolClients {
      clientId
      clientName
    }
  }
`
